import { get, post } from './axios.js'

/**
 * 부서 리스트 조회 - /dept/deptList
 * @returns
 */
export async function deptList(param={}) {
  try {
    const result = await post('/dept/deptList', param)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 부서 등록/수정 - /dept/deptEdit
 * @param {object} params
 * @property {string} params.dept_cd
 * @property {string} params.dept_nm
 * @property {string} params.up_dept_cd
 * @property {string} params.note
 * @property {string} params.enable_yn
 * @property {string} params.upd_id
 * @property {string} params.std_dt 
 * @returns
 */
export async function deptEdit(params = {}) {
  try {
    const result = await post('/dept/deptEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 부서 삭제 - /dept/deptDelete
 * @param {object} params
 * @property {string} params.dept_cd
 * @returns
 */
export async function deptDelete(params = {}) {
  try {
    const result = await post('/dept/deptDelete', params)
    return result.data
  } catch(e) {
    throw e.response;
  }
}
